'use strict'

import store from 'CommonApp/store'
import {Person} from 'janux-people'
import _ from 'lodash'

export function projectService (http, instance) {
	const hydrateContact = (contact) => {
		let person = Person.fromJSON(contact)
		person.contactId = contact.contactId
		person.typeId = contact.typeId
		person.userId = contact.userId
		person.projId = contact.projId
		person.company = (_.isNil(contact.company)) ? '' : contact.company
		return person
	}

	const dehydrateContact = (contact) => {
		const attrs = _.clone(contact)
		let data = contact.toJSON()
		data.typeId = attrs.typeId
		data.userId = attrs.userId
		data.projId = attrs.projId
		data.company = (_.isNil(attrs.company)) ? '' : attrs.company

		if (!_.isNil(attrs.contactId)) {
			data.contactId = attrs.contactId
		}

		return data
	}

	const mapContacts = (contacts) => {
		return _.map(contacts, (contact) => {
			const types = {
				'SG': 'Report Signer',
				'DM': 'Decision Maker'
			}
			return { title: types[contact.typeId], object: hydrateContact(contact) }
		})
	}

	// This allows us to define if a project should be treated
	// mostly as a new construction for TT
	const addFlags = (projObj) => {
		const projType = process.env.PROJTYPE
		if (!_.isNil(projObj.takeoff) && _.isNil(projObj.isNewHome)) {
			// Treated as new building
			projObj.isNewHome = (projObj.takeoff === projType.newBuilding ||
				// Detached addition (new construction with extra info fields )
				projObj.takeoff === projType.detachedAdd ||
				// Remodel, mix of new construction and addition
				projObj.takeoff === projType.remodel)
		}
		return projObj
	}

	return {
		// Load all projects
		findAll: function (filter, active) {
			return http.jsonrpc(
				'/rpc/2.0/projects',
				'findAll',
				[filter, active]
			).then(function (resp) {
				return resp.result.map(addFlags)
			})
		},
		// Load projects by project id
		findByUserId: function (userId, legacyPrj = false) {
			return http.jsonrpc(
				'/rpc/2.0/projects',
				'findByUserId',
				[ userId, legacyPrj ]
			).then(function (resp) {
				return resp.result.map(addFlags)
			})
		},
		// Load projects by project id
		findOneById: function (projId) {
			return http.jsonrpc(
				'/rpc/2.0/projects',
				'findOneById',
				[ projId ]
			).then(function (resp) {
				const proj = addFlags(resp.result)
				proj.contacts = mapContacts(proj.contacts)
				return proj
			})
		},
		// Add new project
		insert: function (userId, data) {
			console.debug('Project about to insert', data)

			data.contacts = (!_.isNil(data.contacts)) ? data.contacts.map((contact) => {
				return dehydrateContact(contact.object)
			}) : null

			return http.jsonrpc(
				'/rpc/2.0/projects',
				'insert',
				[ userId, data ]
			).then(function (resp) {
				const proj = addFlags(resp.result)
				proj.contacts = mapContacts(proj.contacts)
				return proj
			})
		},
		// Add new project
		clone: function (userId, projId) {
			let data = null

			return this.findOneById(projId).then(dataRes => {
				data = dataRes

				data.contacts = (!_.isNil(data.contacts)) ? data.contacts.map((contact) => {
					return dehydrateContact(contact.object)
				}) : null

				return http.jsonrpc(
					'/rpc/2.0/projects',
					'clone',
					[ userId, data ]
				).then(function (resp) {
					const proj = addFlags(resp.result)
					proj.contacts = mapContacts(proj.contacts)
					return proj
				})
			})
		},
		// save project changes
		update: function (project) {
			// console.debug('Project about to update', project)

			project.contacts = (!_.isNil(project.contacts)) ? project.contacts.map((contact) => {
				return dehydrateContact(contact.object)
			}) : null

			return http.jsonrpc(
				'/rpc/2.0/projects',
				'update',
				[ project ]
			).then(function (resp) {
				const proj = addFlags(resp.result)
				proj.contacts = mapContacts(proj.contacts)
				return proj
			})
		},
		// set project isLocked flasg
		setLocked: function (projId, lockedValue) {
			return http.jsonrpc(
				'/rpc/2.0/projects',
				'setLocked',
				[ projId, lockedValue ]
			).then(function (resp) {
				return resp.result
			})
		},
		// Delete project
		delete: function (projId) {
			return http.jsonrpc(
				'/rpc/2.0/projects',
				'delete',
				[ projId ]
			).then(function (resp) {
				return resp.result
			})
		},
		// Check if we have a previously project set as active
		requetActiveProject: function () {
			if (localStorage.activeProject) {
				store.dispatch({
					type: 'updateActiveProject',
					value: localStorage.activeProject
				})
			}
		},
		calculateGlazingOverhangHeight: function (project) {
			//  Formula: (Typical Plate Height - Typical Window Header Height - (Typical Roof Slope from floors & Roofs tab * Typical Overhang Length)) 12
			// Typical Window Header Height
			let tWHH = project.glazing.windowHeadHeight
			// Typical Plate Height
			let tPH = project.glazing.plateHeight
			// Typical Roof Slope
			let tRS = project.floorsRoofs.typRoofSlope
			// Typical Overhang Length
			let tOL = project.glazing.overhangLength

			if (_.isNil(tOL) || tOL < 0 || tOL === '') { tOL = 0 }
			if (_.isNil(tRS) || tRS < 0 || tRS === '') { tRS = 0 }

			// console.log('tPH ', tPH, ' tOL ', tOL, ' tRS ', tRS, ' tWHH ', tWHH)

			return (tPH - (tOL * tRS / 12) - tWHH).toFixed(2)
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/e24-services/project-service.js